/// <amd-module name="Wit/Common/QueryFavoriteProviderDataService" />
import { IFavoriteProviderDataService } from "Favorites/Common/Contracts/Service";
import { Favorite }  from "Favorites/Common/Contracts/Favorite";

import { Services, VssService } from "VSS/Platform/Context";

class QueryFavoriteProviderDataService extends VssService implements IFavoriteProviderDataService {
    public getArtifactType(): string {
        return "Microsoft.TeamFoundation.WorkItemTracking.QueryItem";
    }

    public getToolTipOnHover(favorite: Favorite): string {
        return `${favorite.artifactScope.name}(${((favorite.artifactProperties || {}) as any).QueryPath})`;
    }
}

Services.add("query-favorite-provider-data-service", { serviceFactory: QueryFavoriteProviderDataService });
